import React from 'react'
import { StyledFormLabel } from './style'

const MuiFormLabel = ({ children, ...rest }) => {
  return <StyledFormLabel {...rest}>{children}</StyledFormLabel>
}

export default MuiFormLabel
